export enum AccountType {
  ADMIN = 'admin',
  FREELANCER = 'freelancer',
  BRAND = 'brand',
  STORE = 'store',
  MANAGER = 'manager',
  POPUP = 'popup',
  POTENTIAL = 'potential'
}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/users/account-type.ts